import { Component, HostBinding, inject, signal } from '@angular/core';
import { PAGES } from '@constants/constants';
import { LayoutComponent } from '@layout/layout.component';
import { AbbCommonModule } from 'app/abb-common.module';
import { TPipe, TRANSLATION_PREFIX } from '@pipes/t.pipe';
import { ALARMS_SUBTITLE } from './alarms';

@Component({
  selector: 'abb-alarms',
  standalone: true,
  template: `
    <page-layout [page]="PAGES.ALARMS" [title]="'Alarms' | t">
      <span
        subtitle
        [innerHTML]="subtitle().key | t : subtitle().params"
      ></span>
    </page-layout>
  `,
  styles: ``,
  providers: [
    {
      provide: TRANSLATION_PREFIX,
      useValue: 'alarms',
    },
  ],
  imports: [LayoutComponent, AbbCommonModule, TPipe],
  host: { class: 'flex-1' },
})
export class AlarmsComponent {
  readonly PAGES: PAGES = PAGES;
  subtitle = inject(ALARMS_SUBTITLE);

  @HostBinding('attr.id') componentid = 'alarms-component';
}
